import { OrderImportColumnMappingSchema } from "@redotech/redo-model/outbound-labels/import-schema";
import * as z from "zod/v4";

export const saveCustomImportSchema = {
  name: "saveCustomImportSchema" as const,
  input: z.object({
    id: z.string().optional(),
    name: z.string().min(1),
    columnMapping: OrderImportColumnMappingSchema,
  }),
  output: z.object({ id: z.string() }),
};
